module.exports = __webpack_public_path__ + "ncrpc-logo-narrow.jpg?7293e22ca87be909a89300b94a4af12a";